const hasWindow = typeof window !== 'undefined'

function safeGet(storage, key) {
    if (!hasWindow || !storage) return null
    try {
        return storage.getItem(key)
    } catch (_) {
        return null
    }
}

function safeSet(storage, key, value) {
    if (!hasWindow || !storage) return false
    try {
        storage.setItem(key, value)
        return true
    } catch (_) {
        return false
    }
}

function safeRemove(storage, key) {
    if (!hasWindow || !storage) return false
    try {
        storage.removeItem(key)
        return true
    } catch (_) {
        return false
    }
}

export function safeLocalStorageGet(key) {
    return safeGet(hasWindow ? window.localStorage : null, key)
}

export function safeLocalStorageSet(key, value) {
    return safeSet(hasWindow ? window.localStorage : null, key, value)
}

export function safeLocalStorageRemove(key) {
    return safeRemove(hasWindow ? window.localStorage : null, key)
}

export function safeSessionStorageGet(key) {
    return safeGet(hasWindow ? window.sessionStorage : null, key)
}

export function safeSessionStorageSet(key, value) {
    return safeSet(hasWindow ? window.sessionStorage : null, key, value)
}

export function safeSessionStorageRemove(key) {
    return safeRemove(hasWindow ? window.sessionStorage : null, key)
}

